export const COLORS = [
  "#C86796", "#FFD600", "#00C5C9", "#F72585", "#FFC733", "#33FFF9", "#F9FF33", "#8D33FF",
  "#FF338F", "#33FF8D", "#FF8333", "#33DFFF", "#BF33FF", "#FF3333", "#33FF3F", "#3375FF",
  "#FF33BF", "#FF5733", "#78FF33", "#333DFF", "#FF3382", "#33FFDA", "#A5FF33", "#FFA533",
  "#33FFAD", "#FF6F33", "#33BFFF", "#D4FF33", "#FF333D", "#33FF6B", "#3382FF", "#FF33A5",
  "#B3FF33", "#FFD133", "#33FFC0", "#FF9E33", "#7D33FF", "#FF3338", "#33FF97", "#33A7FF",
  "#FF338B", "#4FFF33", "#FF5F33", "#33FF75", "#3372FF", "#FF33D4", "#C2FF33", "#FFB833",
  "#33FFE1", "#FF3F33"
];
